/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { View } from 'okta';
import Enums from 'util/Enums';
const CAN_REMOVE_BEACON_CLS = 'can-remove-beacon';
export default View.extend({
  tagName: 'main',
  className: 'auth-container main-container',
  id: Enums.WIDGET_CONTAINER_ID,
  attributes: { 'data-se': 'auth-container', tabindex: '-1' },
  initialize: function(options) {
    this.listenTo(options.appState, 'change:beaconType', function(model, type) {
      this.$el.toggleClass(CAN_REMOVE_BEACON_CLS, type === 'security');
    });
  },
});



// WEBPACK FOOTER //
// ./src/views/shared/AuthContainer.js